export const DEFAULT_PAGINATION_PAGE_SIZE = 24;



// WEBPACK FOOTER //
// ./common/pager/constants.js